import React from 'react';
import { useHistory } from 'react-router-dom';
import { GRID_CARD_LINK, DICTIONARY_CARD_LINK } from '../../router/links';
import { RENTED_VEHICLES_GRID } from '../../constants/grids';

import {
    ACTIVE_TYPE,
    BOOLEAN_TYPE,
    CUSTOM_SELECT_TYPE,
    CUSTOM_STATE_TYPE,
    ENUM_TYPE,
    LABELS_TYPE,
    LINK_TYPE,
    LOCAL_DATE_TIME,
    MOSCOW_DATE_TIME,
    NUMBER_TYPE,
    POINT_NUMBER_TYPE,
    VALIDATED_NUMBER_TYPE,
    SELECT_TYPE,
    STATE_TYPE,
    MULTI_ENUM_TYPE,
    MULTI_SELECT_TYPE,
    TRANSPORT_COMPANIES_TYPE,
    BIG_TEXT_TYPE,
    FILE_TYPE, DATE_TIME_TYPE, SHIPPINGS_COUNT_CALENDAR_TYPE, POOLING_TYPE,
} from '../../constants/columnTypes';
import { numbersFormat } from '../../utils/numbersFormat';
import {Checkbox, Label, Table} from 'semantic-ui-react';
import StateValue from './StateValue';
import SelectValue from './SelectValue';
import TextCropping from './TextCropping';
import {dateToMoscow, dateToUTC, formatDate} from '../../utils/dateTimeFormater';
import ToggleCheckbox from './ToogleCheckbox';
import TransportCompanies from './TransportCompanies';
import FacetField from "../FilterComponents";
import {ORDERS_GRID} from "../../constants/grids";

const CellValue = ({
    type,
    value = '',
    valueText,
    valueTooltip,
    name,
    id,
    toggleIsActive,
    source,
    indexRow,
    indexColumn,
    modalCard,
    showRawValue,
    width,
    t,
    isDisabled,
    cardLink,
    gridName,
    rowId,
    row,
    poolingId,
    goToCard,
    decimals,
    alternativeCosts,
    ...extProps
}) => {
    const history = useHistory();
    const userLocale = navigator.languages && navigator.languages.length
                        ? navigator.languages[0]
                        : navigator.language;

    if (type === TRANSPORT_COMPANIES_TYPE) {
        return (
            <TransportCompanies
                id={rowId}
                value={value}
                valueText={valueText}
                width={width}
                source={source}
                indexColumn={indexColumn}
                indexRow={indexRow}
                alternativeCosts={alternativeCosts}
                runId={extProps.runId}
                loadData={extProps.loadData}
            />
        );
    }

    if (type === SELECT_TYPE || type === CUSTOM_SELECT_TYPE) {
        return (
            <SelectValue
                width={width}
                value={value}
                valueText={valueText}
                source={source}
                indexRow={indexRow}
                indexColumn={indexColumn}
                showRawValue={showRawValue}
            />
        );
    }

    if (type === STATE_TYPE || type === CUSTOM_STATE_TYPE) {
        return (
            <StateValue
                width={width}
                value={value}
                source={source}
                indexRow={indexRow}
                indexColumn={indexColumn}
            />
        );
    }

    if (type === LABELS_TYPE) {
        return (
            <>
                {!value
                    ? t('All')
                    : value.map((n, i) => (
                          <Label key={n.name} className="label-margin">
                              {t(n.name)}
                          </Label>
                      ))}
            </>
        );
    }

    if (type === ENUM_TYPE) {
        return (
            <TextCropping width={width} indexColumn={indexColumn}>
                {value ? valueText : ''}
            </TextCropping>
        );
    }

    if (type === ACTIVE_TYPE) {
        return (
            <ToggleCheckbox
                id={id}
                value={value}
                disabled={isDisabled}
                toggleIsActive={toggleIsActive}
            />
        );
    }

    if (type === BOOLEAN_TYPE) {
        return <>{value === true ? t('Yes') : value === false ? t('No') : ''}</>;
    }

    if (type === MULTI_ENUM_TYPE || type === MULTI_SELECT_TYPE) {
        return (
            <TextCropping width={width} indexColumn={indexColumn}>
                {value
            ? value.reduce((str, item) => `${str}${str.length ? ', ' : ''}${item.name}`, '')
            : ''}
            </TextCropping>
        );
    }

    if (type === VALIDATED_NUMBER_TYPE) {
        let cellValue;
        if (valueText !== undefined && valueText !== null && valueText) {
            cellValue = valueText;
        } else if (decimals !== undefined && decimals !== null) {
            cellValue = new Intl.NumberFormat(userLocale, { maximumFractionDigits: decimals }).format(
                numbersFormat(parseFloat(value), decimals),
            ); // new Intl.NumberFormat().format() чтоб разделитель дробной части брался из настроек системы)
        } else {
            cellValue = new Intl.NumberFormat().format(numbersFormat(parseFloat(value)));
        }

        if (valueTooltip !== undefined && valueTooltip !== null && valueTooltip.length > 0) {
            return <span title={valueTooltip}>{cellValue}</span>;
        }
        return <>{cellValue}</>;
    }

    if (value === undefined || value === null) return '';

    if (type === NUMBER_TYPE) {
        if (decimals !== undefined && decimals !== null) {
            return (
                <>
                    {new Intl.NumberFormat(userLocale, { maximumFractionDigits: decimals }).format(
                        numbersFormat(parseFloat(value), decimals),
                    )}
                </>
            ); // new Intl.NumberFormat().format() чтоб разделитель дробной части брался из настроек системы)
        }
        return <>{new Intl.NumberFormat().format(numbersFormat(parseFloat(value)))}</>;
    }

    if (type === POINT_NUMBER_TYPE) {
        return (
            <>{
                <TextCropping width={width} indexColumn={indexColumn}>
                    {value}
                </TextCropping>}</>);
    }

    if (type === POOLING_TYPE) {
        return (
            <a
                className="link-cell"
                href={source.replace('{0}', poolingId)}
                target='_blank'
                rel='noreferrer'
            >
                <TextCropping width={width} indexColumn={indexColumn}>
                    {value}
                </TextCropping>
            </a>
        );
    }

    if (type === LINK_TYPE) {
        const displayValue = valueText || value;
        const linkId = rowId || (valueText ? value : null);

        const handleGoToCard = () => {
            if (goToCard) {
                goToCard(true, linkId, source);
            } else if (source && linkId) {
                const link = source === RENTED_VEHICLES_GRID
                    ? DICTIONARY_CARD_LINK.replace(':name', source).replace(':id', linkId)
                    : GRID_CARD_LINK.replace(':name', source).replace(':id', linkId);
                history.push({
                    pathname: link,
                    state: {
                        pathname: history.location.pathname,
                        gridLocation: history.location.state?.pathname,
                        openedFromCard: true,
                    },
                });
            }
        };

        return (
            (goToCard || (source && linkId)) ? (
                <div className="link-cell" onClick={handleGoToCard}>
                    <TextCropping width={width} indexColumn={indexColumn}>
                        {displayValue}
                    </TextCropping>
                </div>
            ) : (
                <TextCropping width={width} indexColumn={indexColumn}>
                    {displayValue}
                </TextCropping>
            )
        );
    }

    if (type === SHIPPINGS_COUNT_CALENDAR_TYPE) {
        return (
            <>
                {value
                    ? <Table celled className="inner-report-table-cell">
                            <Table.Header>
                                <Table.Row>
                                    {value.map((item) => (
                                        <Table.HeaderCell className="report-table-cell">
                                            {item.date}
                                        </Table.HeaderCell>
                                    ))}
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                <Table.Row>
                                    {value.map((item) => (
                                        <Table.Cell className="report-table-cell">
                                            {item.count}
                                        </Table.Cell>
                                    ))}
                                </Table.Row>
                            </Table.Body>
                        </Table>
                    : "[]"
                }
            </>
        );
    }

    if (type === LOCAL_DATE_TIME) {
        return (
            <TextCropping width={width} indexColumn={indexColumn}>
                {dateToUTC(value, 'DD.MM.YYYY HH:mm')}
            </TextCropping>
        );
    }

    if (type === MOSCOW_DATE_TIME) {
        return (
            <TextCropping width={width} indexColumn={indexColumn}>
                {dateToMoscow(value, 'DD.MM.YYYY HH:mm')}
            </TextCropping>
        );
    }

    if (type === BIG_TEXT_TYPE) {
        return (
            <TextCropping width={width} indexColumn={indexColumn}>
                {
                    value.replace(/<div>/g, '\n')
                    .replace(/<\/div>/g, '')
                    .replace(/<br>/g, '\n')
                    .replace(/&nbsp;/g, ' ')
                }
            </TextCropping>
        );
    }

    if (type === FILE_TYPE) {
        return (
            <TextCropping width={width} indexColumn={indexColumn}>
                {valueText}
            </TextCropping>
        );
    }

    return (
        <TextCropping width={width} indexColumn={indexColumn}>
            {value}
        </TextCropping>
    );
};

export default React.memo(CellValue);
